var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3042 0.630371H0.740189V27.1944H27.3042V0.630371ZM22.8783 22.7685H5.16781V5.058H22.8783V22.7685Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59427 9.48438H18.4486V18.3387H9.59427V9.48438Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.740143 70.7886H27.3041V44.2246H0.740143V70.7886ZM5.16777 48.6505H22.8783V66.3627H5.16777V48.6505Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59427 53.0791H18.4486V61.9335H9.59427V53.0791Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6169 0.630371V27.1944H71.1809V0.630371H44.6169ZM66.755 22.7685H49.0445V5.058H66.755V22.7685Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4717 9.48438H62.3261V18.3387H53.4717V9.48438Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59451 31.2812H0.740143V40.1356H14.0221V35.7089H9.59451V31.2812Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5337 40.0371H40.3881V48.8915H31.5337V40.0371Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9366 31.3071H22.7909V35.7348H13.9366V31.3071Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3881 53.0791H31.5337V57.5067H35.9613V61.9344H40.389V53.0791H40.3881Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1631 31.2812V35.7089H22.7355V40.1365H31.5899V31.2812H27.1631Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9486 18.144H40.3762V26.9984H35.9486V18.144Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3425 35.7089V40.1365H49.1969V31.2812H35.9149V35.7089H40.3425Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.546 26.9233H35.9736V31.351H31.546V26.9233Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3297 61.9365H49.1841V70.7909H40.3297V61.9365Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.546 61.9365H35.9736V70.7909H31.546V61.9365Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3512 48.8315H44.7788V53.2592H40.3512V48.8315Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3881 13.9124V5.058H35.9613V0.630371H31.5337V18.34H35.9613V13.9124H40.3881Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.552 61.9365H57.9796V70.7909H53.552V61.9365Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4717 53.2212H62.3261V57.6488H53.4717V53.2212Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1511 57.5068H53.5787V61.9345H49.1511V57.5068Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7477 53.2212H49.1754V57.6488H44.7477V53.2212Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3289 44.4219V48.8495H66.7566V53.2771H71.1842V44.4219H62.3289Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7566 57.5068H62.3289V70.7888H71.1833V61.9345H66.7566V57.5068Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.708 44.4647V48.8924H57.99V40.0371H49.1356V44.4647H44.708Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4717 31.2812V35.7089H62.3261V40.1365H71.1813V31.2812H53.4717Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.481382fd9cebb0f2631922d9dac62efa.svg";
export { ForwardRef as ReactComponent };